export default __webpack_public_path__ + "static/media/character-yeti-sad.6ec90482.png";